/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTaskCommandResult } from '../../models/create-task-command-result';
import { TaskCategory } from '../../models/task-category';

export interface ApiTaskCreateTaskPost$Plain$Params {
      body?: {
'Subject'?: string;
'Description'?: string;
'StakeholderId'?: number;
'EndDate'?: string;
'AdditionalDetails'?: string;
'TaskCategory': TaskCategory;
'Attachments'?: Array<Blob>;
'MeetingId'?: string;
'ResponsibleIds'?: Array<string>;
'CopyToList'?: Array<string>;
}
}

export function apiTaskCreateTaskPost$Plain(http: HttpClient, rootUrl: string, params?: ApiTaskCreateTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskCreateTaskPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateTaskCommandResult>;
    })
  );
}

apiTaskCreateTaskPost$Plain.PATH = '/api/Task/CreateTask';
